module.exports = __webpack_public_path__ + "static/media/autocheck-logo.59fb3e2b.png";